// services/frontend/src/utils/critiqueTree.ts
// Utility functions for building and managing critique tree structures

import { Critique } from '../types/critique';

/**
 * Build nested tree structure from flat list of critiques
 * This transforms the flat array from the API into a hierarchical structure
 * with children nested under their parent comments
 *
 * @param flatCritiques - Flat array of critiques from API
 * @returns Array of root-level critiques with nested children
 */
export function buildCritiqueTree(flatCritiques: Critique[]): Critique[] {
  const map = new Map<string, Critique>();
  const roots: Critique[] = [];

  // First pass: create map with all critiques and initialize children array
  flatCritiques.forEach(critique => {
    map.set(critique.id, { ...critique, children: [] });
  });

  // Second pass: build tree by connecting parents and children
  flatCritiques.forEach(critique => {
    const node = map.get(critique.id)!;

    if (critique.parentId) {
      const parent = map.get(critique.parentId);
      if (parent) {
        parent.children?.push(node);
      }
    } else {
      // Top-level comment (no parent)
      roots.push(node);
    }
  });

  return roots;
}
